import { insertAfter } from "AC/helpers/elements";
var LayoutSwitcher = /** @class */ (function () {
    function LayoutSwitcher(element) {
        this.element = element;
    }
    LayoutSwitcher.prototype.place = function () {
        var _this = this;
        [
            '.wrap > a.page-title-action',
            '.wrap h1',
            '.wrap h2',
            '.wrap div'
        ].some(function (selector) {
            return _this.tryPlacement(selector);
        });
    };
    LayoutSwitcher.prototype.tryPlacement = function (selector) {
        var predecessor = document.querySelector(selector);
        if (!predecessor) {
            return false;
        }
        insertAfter(this.element, predecessor);
        this.element.classList.add('-moved');
        return true;
    };
    return LayoutSwitcher;
}());
export default LayoutSwitcher;
